<script setup lang="ts">
import FlashMessageItem from '@shop/components/ui/FlashMessageItem.vue';
import useFlashStore from '@shop/store/flash';

const flashStore = useFlashStore();
</script>

<template>
  <TransitionGroup
    name="flash-toast"
    tag="div"
    class="flashmessage__container flashmessage__container--toast"
    aria-live="polite"
  >
    <div
      v-for="message in flashStore.messages"
      :key="message.id"
      class="flashmessage__item--container"
    >
      <FlashMessageItem
        :id="message.id"
        :level="message.level"
        :message="message.message"
        @dismiss="flashStore.remove"
      />
    </div>
  </TransitionGroup>
</template>
